// Every Insure route component, loaded with the first Insure page opened.
// Insure's stylesheet comes first, so its page components' own styles still follow it.
import '../css/index.css'
// Before the editor's Prism language files, which need the global Prism sets.
import 'prismjs'

import { IndexRedirect } from './IndexRedirect'
import { InsureFrame } from './InsureFrame'
import { AcceptInvitation } from './Private/App/AcceptInvitation'
import { AdminLayout } from './Private/App/AdminLayout'
import { AdminSettings } from './Private/App/AdminSettings/AdminSettings'
import { AppLayout } from './Private/App/AppLayout'
import { Certificates } from './Private/App/Certificates/Certificates'
import { Claims } from './Private/App/Claims'
import { EditClaim } from './Private/App/Claims/EditClaim'
import { NewClaim } from './Private/App/Claims/NewClaim'
import { CustomerDetail } from './Private/App/Customers/CustomerDetail'
import { Customers } from './Private/App/Customers/Customers'
import { Documents } from './Private/App/Documents'
import { Drivers } from './Private/App/Drivers'
import { FleetDetails } from './Private/App/FleetDetails/FleetDetails'
import { Insurance } from './Private/App/Insurance'
import { AgentChat } from './Private/App/Internal/AgentChat/AgentChat'
import { AgentReporting } from './Private/App/Internal/AgentReporting/AgentReporting'
import { AgentTools } from './Private/App/Internal/AgentTools/AgentTools'
import { ApplicationDetail } from './Private/App/Internal/ApplicationDetail'
import { Applications } from './Private/App/Internal/Applications'
import { CallsIndex } from './Private/App/Internal/Calls/CallsIndex'
import { Carriers } from './Private/App/Internal/Carriers/Carriers'
import { CoiGenerator } from './Private/App/Internal/CoiGenerator'
import { CoiGeneratorDetail } from './Private/App/Internal/CoiGeneratorDetail'
import { CoiRequests } from './Private/App/Internal/CoiRequests'
import { CorgiConnection } from './Private/App/Internal/CorgiConnection/CorgiConnection'
import { EmailReportingIndex } from './Private/App/Internal/EmailReporting/EmailReportingIndex'
import { EmailsIndex } from './Private/App/Internal/Emails/EmailsIndex'
import { EmailTemplatesIndex } from './Private/App/Internal/EmailTemplates/EmailTemplatesIndex'
import { InternalEndorsements } from './Private/App/Internal/Endorsements/InternalEndorsements'
import { InternalClaims } from './Private/App/Internal/InternalClaims'
import { InternalLayout } from './Private/App/Internal/InternalLayout'
import { MyPipeline } from './Private/App/Internal/MyPipeline/MyPipeline'
import { PendingEquipmentChanges } from './Private/App/Internal/PendingEquipmentChanges'
import { QuotesAnalytics } from './Private/App/Internal/QuotesAnalytics/QuotesAnalytics'
import { RemindersPage } from './Private/App/Internal/Reminders/RemindersPage'
import { Requotes } from './Private/App/Internal/Requotes/Requotes'
import { SalesAnalytics } from './Private/App/Internal/SalesAnalytics/SalesAnalytics'
import { PipelineBoard } from './Private/App/Internal/SalesLeads/Pipeline/PipelineBoard'
import { SalesLeads } from './Private/App/Internal/SalesLeads/SalesLeads'
import { SequenceDetail } from './Private/App/Internal/Sequences/SequenceDetail'
import { SequencesIndex } from './Private/App/Internal/Sequences/SequencesIndex'
import { SequenceTemplatesIndex } from './Private/App/Internal/SequenceTemplates/SequenceTemplatesIndex'
import { SmsIndex } from './Private/App/Internal/Sms/SmsIndex'
import { StaffUserDetail } from './Private/App/Internal/StaffUserDetail/StaffUserDetail'
import { StaffUsers } from './Private/App/Internal/StaffUsers'
import { WorkQueue } from './Private/App/Internal/WorkQueue/WorkQueue'
import { NewPolicyChange } from './Private/App/PolicyChanges/NewPolicyChange'
import { PolicyChangePage } from './Private/App/PolicyChanges/PolicyChangePage'
import { PolicyChanges } from './Private/App/PolicyChanges/PolicyChanges'
import { PolicyChangeUpdatePage } from './Private/App/PolicyChanges/PolicyChangeUpdatePage'
import { QaEmails } from './Private/App/QA/Emails/QaEmails'
import { GeicoQa } from './Private/App/QA/Geico/GeicoQa'
import { QA } from './Private/App/QA/QA'
import { Cab } from './Private/App/Sales/Cab'
import { InsuranceEstimator } from './Private/App/Sales/InsuranceEstimator'
import { Vin } from './Private/App/Sales/Vin'
import { Trailers } from './Private/App/Trailers'
import { Trucks } from './Private/App/Trucks'
import {
  CarrierFilePage,
  DriverFilePage,
  TimelinePage,
  TrailerFilePage,
  TruckFilePage,
} from './Private/App/Vault/pages'
import { VaultFolders } from './Private/App/Vault/VaultFolders'
import { VaultPage } from './Private/App/VaultPage'
import { ViolationDetail } from './Private/App/Violations/ViolationDetail'
import { Violations } from './Private/App/Violations/Violations'
import { ConfirmInfoPage } from './Private/ConfirmInfo/ConfirmInfoPage'
import { DesignSystem } from './Private/DesignSystem/DesignSystem'
import { AccountBannerFrame } from './Private/DesignSystem/frames/AccountBannerFrame'
import { ClaimFrame } from './Private/DesignSystem/frames/ClaimFrame'
import { NavFrame } from './Private/DesignSystem/frames/NavFrame'
import { AccountBannersPrototypePage } from './Private/DesignSystem/prototypes/AccountBanners/AccountBannersPrototypePage'
import { AccountSideNavPrototypePage } from './Private/DesignSystem/prototypes/AccountSideNav/AccountSideNavPrototypePage'
import { AiPositioningPrototypePage } from './Private/DesignSystem/prototypes/AiPositioning/AiPositioningPrototypePage'
import { CaiMvpFullPage } from './Private/DesignSystem/prototypes/AiPositioning/CaiMvpFullPage'
import { CheckoutManagerPrototypePage } from './Private/DesignSystem/prototypes/CheckoutManager/CheckoutManagerPrototypePage'
import { ClaimsPrototypePage } from './Private/DesignSystem/prototypes/Claims/ClaimsPrototypePage'
import { ConfirmInfoCardsPrototypePage } from './Private/DesignSystem/prototypes/ConfirmInfoCards/ConfirmInfoCardsPrototypePage'
import { QuoteCardPrototypePage } from './Private/DesignSystem/prototypes/QuoteCard/QuoteCardPrototypePage'
import { QuotesPagePrototype } from './Private/DesignSystem/prototypes/Quotes/QuotesPagePrototype'
import { ConversationTreePage } from './Private/DesignSystem/sections/ConversationTree/ConversationTreePage'
import { InsuranceApplication } from './Private/InsuranceApplication'
import { TimeToQuotingLayout } from './Private/InsuranceApplication/TimeToQuotingLayout'
import { InsuranceQuotes } from './Private/InsuranceQuotes'
import { NavigationLayout } from './Private/NavigationLayout'
import { PrivateLayout } from './Private/PrivateLayout'
import { SignBor } from './Private/SignBor'
import { SignEnvelope } from './Private/SignEnvelope'
import { UploadLossRuns } from './Private/UploadLossRuns'
import { ClaimPhotosPage } from './Public/ClaimPhotosPage'
import { CreateTestAdmin } from './Public/CreateTestAdmin'
import { CreateTestUser } from './Public/CreateTestUser'
import { EmbedDemo } from './Public/EmbedDemo'
import { GetEstimatesFlow } from './Public/GetEstimates/GetEstimatesFlow'
import { Impersonate } from './Public/Impersonate'
import { LargeFleetConfirmPage } from './Public/LargeFleet/LargeFleetConfirmPage'
import { LargeFleetPage } from './Public/LargeFleet/LargeFleetPage'
import { AiCfo } from './Public/marketing/AiCfo'
import { AmazonRelay } from './Public/marketing/AmazonRelay'
import { Bookkeeper as BookkeeperLanding } from './Public/marketing/Bookkeeper'
import { FuelApp } from './Public/marketing/FuelApp'
import { FuelAppReferral } from './Public/marketing/FuelAppReferral'
import { FuelAppTeams } from './Public/marketing/FuelAppTeams'
import { GroupCaptive } from './Public/marketing/GroupCaptive'
import { Home } from './Public/marketing/Home'
import { HowWeUseAi } from './Public/marketing/HowWeUseAi'
import { Insurance as MarketingInsurance } from './Public/marketing/Insurance'
import { InsuranceVertical } from './Public/marketing/InsuranceVertical'
import { LargeFleets } from './Public/marketing/LargeFleets'
import { MarketingLayout } from './Public/marketing/MarketingLayout'
import { Privacy } from './Public/marketing/Privacy'
import { Terms } from './Public/marketing/Terms'
import { NewAuthorityStart } from './Public/NewAuthorityStart'
import { NotFound } from './Public/NotFound'
import { DarkProductFlowLayout, ProductFlowLayout } from './Public/ProductFlowLayout'
import { PublicQuotes } from './Public/PublicQuotes'
import { SignUpPage } from './Public/SignUpPage'
import { StartApplication } from './Public/StartApplication/StartApplication'

export const insurePages = {
  InsureFrame,
  IndexRedirect,
  AcceptInvitation,
  AdminLayout,
  AdminSettings,
  AppLayout,
  Certificates,
  Claims,
  EditClaim,
  NewClaim,
  PolicyChanges,
  NewPolicyChange,
  PolicyChangePage,
  PolicyChangeUpdatePage,
  CustomerDetail,
  Customers,
  Documents,
  Drivers,
  FleetDetails,
  Insurance,
  AgentChat,
  AgentReporting,
  AgentTools,
  ApplicationDetail,
  Applications,
  CallsIndex,
  Carriers,
  CorgiConnection,
  CoiGenerator,
  CoiGeneratorDetail,
  CoiRequests,
  EmailReportingIndex,
  EmailsIndex,
  EmailTemplatesIndex,
  InternalClaims,
  InternalEndorsements,
  InternalLayout,
  PendingEquipmentChanges,
  QuotesAnalytics,
  RemindersPage,
  Requotes,
  SalesAnalytics,
  PipelineBoard,
  SalesLeads,
  SequenceDetail,
  SequencesIndex,
  SequenceTemplatesIndex,
  SmsIndex,
  StaffUserDetail,
  StaffUsers,
  WorkQueue,
  MyPipeline,
  QaEmails,
  GeicoQa,
  QA,
  Cab,
  InsuranceEstimator,
  Vin,
  Trailers,
  Trucks,
  CarrierFilePage,
  DriverFilePage,
  TimelinePage,
  TrailerFilePage,
  TruckFilePage,
  VaultFolders,
  VaultPage,
  ViolationDetail,
  Violations,
  DesignSystem,
  AccountBannerFrame,
  ClaimFrame,
  NavFrame,
  AccountBannersPrototypePage,
  AccountSideNavPrototypePage,
  AiPositioningPrototypePage,
  CheckoutManagerPrototypePage,
  CaiMvpFullPage,
  ClaimsPrototypePage,
  ConfirmInfoCardsPrototypePage,
  QuoteCardPrototypePage,
  QuotesPagePrototype,
  ConversationTreePage,
  InsuranceApplication,
  ConfirmInfoPage,
  TimeToQuotingLayout,
  InsuranceQuotes,
  NavigationLayout,
  PrivateLayout,
  SignBor,
  SignEnvelope,
  UploadLossRuns,
  ClaimPhotosPage,
  CreateTestAdmin,
  CreateTestUser,
  EmbedDemo,
  GetEstimatesFlow,
  Impersonate,
  LargeFleetConfirmPage,
  LargeFleetPage,
  AiCfo,
  BookkeeperLanding,
  FuelApp,
  FuelAppReferral,
  FuelAppTeams,
  AmazonRelay,
  GroupCaptive,
  Home,
  HowWeUseAi,
  MarketingInsurance,
  InsuranceVertical,
  LargeFleets,
  MarketingLayout,
  Privacy,
  Terms,
  NewAuthorityStart,
  NotFound,
  DarkProductFlowLayout,
  ProductFlowLayout,
  PublicQuotes,
  SignUpPage,
  StartApplication,
}
